import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../_metronic/helpers'
import {City, CityQueryResponse} from './_models'

const API_URL = process.env.REACT_APP_THEME_API_URL
const CITY_URL = `${API_URL}/city`
// const GET_COUNTRIES_URL = `${API_URL}/user`

const getCities = (query: string): Promise<CityQueryResponse> => {
  return axios
    .get(`${CITY_URL}?${query}`)
    .then((d: AxiosResponse<CityQueryResponse>) => d.data)
}
const getCityById = (id: ID): Promise<City | undefined> => {
  return axios
    .get(`${CITY_URL}/${id}`)
    .then((response: AxiosResponse<Response<City>>) => response.data)
    .then((response: Response<City>) => response.data)
}

const createCity = (model: City): Promise<CityQueryResponse | undefined> => {
  return axios
    .post(CITY_URL, model)
    .then((response: AxiosResponse<CityQueryResponse>) => response.data)
    .then((response: CityQueryResponse) => response)
}

const updateCity = (model: City): Promise<CityQueryResponse> => {
  return axios
    .post(`${CITY_URL}/${model.id}`, model)
    .then((response: AxiosResponse<CityQueryResponse>) => response.data)
    .then((response: CityQueryResponse) => response)
}

const deleteCity = (modelId: ID): Promise<CityQueryResponse | undefined> => {
  return axios
  .delete(`${CITY_URL}/${modelId}`)
  .then((response: AxiosResponse<CityQueryResponse>) => response.data)
    .then((response: CityQueryResponse) => response)
}

const deleteSelectedCities = (modelIds: Array<ID>): Promise<void> => {
  const requests = modelIds.map((id) => axios.delete(`${CITY_URL}/${id}`))
  return axios.all(requests).then(() => {})
}

export {getCities,getCityById,createCity,updateCity,deleteCity,deleteSelectedCities}
